<template>
    <div
        v-if="totalPages > 1"
        class="flex flex-wrap items-center justify-between gap-3 border-t border-taupe-200 px-2 py-3"
    >
        <p class="text-sm text-taupe-600" data-testid="pagination-summary">
            Page <span class="font-medium text-taupe-800">{{ page }}</span> of
            <span class="font-medium text-taupe-800">{{ totalPages }}</span>
            <span v-if="total !== null">
                ({{ total }} {{ total === 1 ? 'result' : 'results' }})</span
            >
        </p>
        <div class="flex gap-2">
            <zen-button
                variant="secondary"
                size="small"
                :disabled="page <= 1"
                data-testid="pagination-prev"
                @click="$emit('change', page - 1)"
            >
                Previous
            </zen-button>
            <zen-button
                variant="secondary"
                size="small"
                :disabled="page >= totalPages"
                data-testid="pagination-next"
                @click="$emit('change', page + 1)"
            >
                Next
            </zen-button>
        </div>
    </div>
</template>

<script setup>
defineProps({
    page: {
        type: Number,
        required: true,
    },
    totalPages: {
        type: Number,
        required: true,
    },
    total: {
        type: Number,
        default: null,
    },
})

defineEmits(['change'])
</script>
